import type { SessionInfoDto } from '../dtos/auth';
import type { EmployeePermission } from '../../shared/constants/permissions';

/** Authenticated employee session used throughout the app. */
export class Session {
  readonly name: string;
  readonly email: string;
  readonly permissions: string[];

  constructor(params: { name?: string; email?: string; permissions?: string[] }) {
    this.name = params.name ?? '';
    this.email = params.email ?? '';
    this.permissions = params.permissions ?? [];
  }

  hasPermission(permission: EmployeePermission): boolean {
    return this.permissions.includes(permission);
  }
}

export const SessionMapper = {
  fromDto(dto: SessionInfoDto): Session {
    return new Session({
      name: dto.name,
      email: dto.email,
      permissions: dto.permissions ?? [],
    });
  },
};
